import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-63.jpg'
import _imports_1 from '@/assets/images/user-64.jpg'
import _imports_2 from '@/assets/images/user-65.jpg'
import _imports_3 from '@/assets/images/user-66.jpg'


const _hoisted_1 = {
  class: "bg-white rounded-3 mb-4",
  style: {"background":"linear-gradient(73deg, #23272e 0%, #343a46 100%)"}
}
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_4 = { class: "ms-m-15" }
const _hoisted_5 = { class: "ms-m-15" }
const _hoisted_6 = { class: "ms-m-15" }
const _hoisted_7 = { class: "ms-m-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mb-3 pb-2" }, [
        _createElementVNode("span", {
          class: "d-block mb-2",
          style: {"color":"#8695aa"}
        }, " New Customers This Month "),
        _createElementVNode("h3", { class: "text-white mb-0 fs-20" }, "4,712")
      ], -1)),
      _cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "d-block mb-2",
        style: {"color":"#8695aa"}
      }, "Join Today", -1)),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                style: {"width":"40px","height":"40px"},
                class: "rounded-circle border border-1 border-color-white",
                alt: "user"
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_1,
                style: {"width":"40px","height":"40px"},
                class: "rounded-circle border border-1 border-color-white",
                alt: "user"
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_2,
                style: {"width":"40px","height":"40px"},
                class: "rounded-circle border border-1 border-color-white",
                alt: "user"
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_3,
                style: {"width":"40px","height":"40px"},
                class: "rounded-circle border border-1 border-color-white",
                alt: "user"
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createVNode(_component_RouterLink, {
            to: "/users/users-list",
            class: "rounded-circle d-block text-center text-decoration-none text-white fs-14 fw-bold border border-1 border-color-white",
            style: {"background-color":"#fe7a36","width":"40px","height":"40px","line-height":"40px"}
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" 59 ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}